import { useEffect, useRef } from 'react'

export const ScrollAnchor = ({ watchedContent }: { watchedContent: string | undefined }) => {
	const ref = useRef<HTMLDivElement | null>(null)

	useEffect(() => {
		ref.current?.scrollIntoView({ behavior: 'smooth' })
	}, [watchedContent])

	return <div ref={ref} />
}
